import { AddEngagementDetailsType } from "../regional-multipliers/saga-actions";

export type EngagementCategoryPayloadType = {
  ID?: number;
  category_name: string;
};

export const partnerEngagementConfigurationSagaActionTypes = {
  callPartnerEngagementConfigurationSaga: "callPartnerEngagementConfigurationSaga",
  callUpdatePartnerEngagementConfigurationSaga: "callUpdatePartnerEngagementConfigurationSaga",
  callDeletePartnerEngagementConfigurationSaga: "callDeletePartnerEngagementConfigurationSaga",
  callAddPartnerEngagementConfigurationSaga: "callAddPartnerEngagementConfigurationSaga",
  callAddPartnerEngagementCategorySaga: "callAddPartnerEngagementCategorySaga",
  callInsertEngagementCategorySaga: "callInsertEngagementCategorySaga",
  callAddStandaloneEngagementCategorySaga: "callAddStandaloneEngagementCategorySaga",
  callUpdateEngagementCategorySaga: "callUpdateEngagementCategorySaga",
  callDeleteEngagementCategorySaga: "callDeleteEngagementCategorySaga",
};


export const getPartnerEngagementConfigurationListSagaAction: () => {
  type: string;
} = () => {
  return {
    type: partnerEngagementConfigurationSagaActionTypes.callPartnerEngagementConfigurationSaga,
  };
};


export const getPartnerEngagementCategoryListSagaAction: () => {
  type: string;
} = () => {
  return {
    type: partnerEngagementConfigurationSagaActionTypes.callAddPartnerEngagementCategorySaga,
  };
};



export const insertEngagementCategorySagaAction: (data: AddEngagementDetailsType) => {
  type: string;
 payload: AddEngagementDetailsType;
} = (data: AddEngagementDetailsType) => {
  return {
    type: partnerEngagementConfigurationSagaActionTypes.callInsertEngagementCategorySaga,
    payload: data,
  };
};

export const addEngagementCategorySagaAction: (
  data: EngagementCategoryPayloadType
) => {
  type: string;
  payload: EngagementCategoryPayloadType;
} = (data) => ({
  type: partnerEngagementConfigurationSagaActionTypes.callAddStandaloneEngagementCategorySaga,
  payload: data,
});

export const updateEngagementCategorySagaAction: (
  data: EngagementCategoryPayloadType
) => {
  type: string;
  payload: EngagementCategoryPayloadType;
} = (data) => ({
  type: partnerEngagementConfigurationSagaActionTypes.callUpdateEngagementCategorySaga,
  payload: data,
});

export const deleteEngagementCategorySagaAction: (ID: number) => {
  type: string;
  payload: { ID: number };
} = (ID) => ({
  type: partnerEngagementConfigurationSagaActionTypes.callDeleteEngagementCategorySaga,
  payload: { ID },
});


export const addEnagagementSagaAction: (data: AddEngagementDetailsType) => {
  type: string;
  payload: AddEngagementDetailsType;
} = (data: AddEngagementDetailsType) => {
  return {
    type: partnerEngagementConfigurationSagaActionTypes.callAddPartnerEngagementConfigurationSaga,
    payload: data,
  };
};


export const updateEnagagementSagaAction: (data: AddEngagementDetailsType) => {
  type: string;
  payload: AddEngagementDetailsType;
} = (data: AddEngagementDetailsType) => {
  return {
    type: partnerEngagementConfigurationSagaActionTypes.callUpdatePartnerEngagementConfigurationSaga,
    payload: data,
  };
};



export const deleteEngagementListSaga: (ID: number) => {
  type: string;
  payload: {
    ID: number;
  };
} = (ID: number) => {
  return {
    type: partnerEngagementConfigurationSagaActionTypes.callDeletePartnerEngagementConfigurationSaga,
    payload: {
      ID: ID,
    },
  };
};
